import {
  BaseballEventStatusId,
  BaseballIncidentId,
  CommonIncidentId,
} from '@collector/sportsapi-client-legacy'

import {
  getBlockedPocketIncidentsMap,
  PocketIncidents,
  PocketIncidentsConfig,
} from '../../configuration/pocketIncidentsConfig'

const pocketIncidents: PocketIncidents = [
  {
    incidentId: CommonIncidentId.TechnicalProblems,
    title: 'TECH',
  },
]

const morePocketIncidents: PocketIncidents = [
  {
    incidentId: BaseballIncidentId.TVTimeout,
    title: 'TV Timeout',
  },
  {
    incidentId: BaseballIncidentId.UnderReview,
    title: 'Under review',
  },
  {
    incidentId: BaseballIncidentId.BreakDuringTheGame,
    title: 'Break during the game',
  },
]

const blockedStatuses: BaseballEventStatusId[] = [
  BaseballEventStatusId.Abandoned,
  BaseballEventStatusId.Cancelled,
  BaseballEventStatusId.NotStarted,
  BaseballEventStatusId.StartDelayed,
  BaseballEventStatusId.Postponed,
  BaseballEventStatusId.FinishedAwardedWin,
  BaseballEventStatusId.Interrupted,
  BaseballEventStatusId.Finished,
  BaseballEventStatusId.ToFinish,
  BaseballEventStatusId.BreakAfterFirstInning,
  BaseballEventStatusId.BreakAfterSecondInning,
  BaseballEventStatusId.BreakAfterThirdInning,
  BaseballEventStatusId.BreakAfterFourthInning,
  BaseballEventStatusId.BreakAfterFifthInning,
  BaseballEventStatusId.BreakAfterSixthInning,
  BaseballEventStatusId.BreakAfterSeventhInning,
  BaseballEventStatusId.BreakAfterEighthInning,
  BaseballEventStatusId.BreakAfterNinthInning,
  BaseballEventStatusId.BreakAfterTenthInning,
  BaseballEventStatusId.BreakAfterEleventhInning,
  BaseballEventStatusId.BreakAfterTwelfthInning,
  BaseballEventStatusId.BreakAfterThirteenthInning,
  BaseballEventStatusId.BreakAfterFourteenthInning,
  BaseballEventStatusId.BreakAfterFifteenthInning,
  BaseballEventStatusId.BreakAfterSixteenthInning,
  BaseballEventStatusId.BreakAfterSeventeenthInning,
  BaseballEventStatusId.BreakAfterEighteenthInning,
  BaseballEventStatusId.BreakAfterNineteenthInning,
  BaseballEventStatusId.BreakAfterTwentiethInning,
  BaseballEventStatusId.BreakAfterTwentyFirstInning,
  BaseballEventStatusId.BreakAfterTwentySecondInning,
]

const blockedPocketIncidentsMap = getBlockedPocketIncidentsMap(
  pocketIncidents,
  morePocketIncidents,
  blockedStatuses,
)

export const pocketIncidentsConfig: PocketIncidentsConfig = {
  pocketIncidents,
  morePocketIncidents,
  blockedPocketIncidentsMap,
}
